import React, { useEffect, useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import RiskTradeChart from "../Charts/RiskTradeChart";
import ConcurrentChart from "../Charts/ConcurrentChart";
import LotsDayChart from "../Charts/LotsDayChart";
import LotsTradeChart from "../Charts/LotsTradeChart";
import "../../assets/css/tradesLots.scss";
import MobileTabs from "../../reusableComponents/MobileTabs/MobileTabs";

const TradesLots = ({
  LotsPerTrade,
  TradesLotsPerDay,
  ConcurrentTrades,
  RiskPerTrade,
}) => {
  const [value, setValue] = React.useState("1");

  console.log(RiskPerTrade,"RiskPerTradeRiskPerTrade  ");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [activeTab, setActiveTab] = useState(value);

  useEffect(() => {
    setValue(activeTab);
  }, [activeTab]);

  const tabItems = [
    {
      name: "Risk Per Trade",
      value: "1",
    },
    {
      name: "Concurrent Trades & Lots Per Day",
      value: "2",
    },
    {
      name: "Trades Lots Per Day",
      value: "3",
    },
    {
      name: "Lots Per Trade",
      value: "4",
    },
  ];

  return (
    <div style={{ width: "100%" }} className="Container-p-20">
      <Box className="ContainerTab TradersLots" sx={{ width: "100%" }}>
        <TabContext value={value}>
          <Box
            className="mbb-30 SubTab "
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab
                className="ContainertabName"
                label="Risk per trade"
                value="1"
              />
              <Tab
                className="ContainertabName"
                label="Concurrent trades & Lots per day"
                value="2"
              />
              <Tab
                className="ContainertabName"
                label="Trades & Lots per day"
                value="3"
              />
              <Tab
                className="ContainertabName"
                label="Lots per trade"
                value="4"
              />
            </TabList>
            <div className="mobileTabOption">
              <MobileTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabItems={tabItems}
              />
            </div>
          </Box>
          <TabPanel value="1" sx={{ padding: 0 }}>
            <RiskTradeChart data={RiskPerTrade && RiskPerTrade} />
          </TabPanel>
          <TabPanel value="2" sx={{ padding: 0 }}>
            <ConcurrentChart data={ConcurrentTrades && ConcurrentTrades} />
          </TabPanel>
          <TabPanel value="3" sx={{ padding: 0 }}>
            <LotsDayChart data={TradesLotsPerDay && TradesLotsPerDay} />
          </TabPanel>
          <TabPanel value="4" sx={{ padding: 0 }}>
            <LotsTradeChart data={LotsPerTrade && LotsPerTrade} />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
};

export default TradesLots;
